import React from 'react';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import type { AdminConfirmationDialogProps } from '../../types/adminConfirmationDialog';
import { adminColors, adminTypography } from '../../styles/adminDesignTokens';
import {
  adminButtonSx,
  adminButtonToneSx,
  adminCombineSx,
  adminDialogActionsSx,
  adminDialogContentSx,
  adminDialogSx,
  adminDialogTitleSx,
} from '../../styles/adminComponentStyles';

const AdminConfirmationDialog: React.FC<AdminConfirmationDialogProps> = ({
  confirmButtonText,
  confirmTone,
  message,
  onCancel,
  onConfirm,
  open,
  submitting = false,
  title,
}) => (
  <Dialog
    fullWidth
    maxWidth="xs"
    open={open}
    onClose={submitting ? undefined : onCancel}
    PaperProps={{ sx: adminDialogSx }}
  >
    <DialogTitle sx={adminCombineSx(adminDialogTitleSx, { alignItems: 'center', display: 'flex', gap: 1 })}>
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: adminColors.warningBackground,
          borderRadius: '8px',
          color: adminColors.warning,
          display: 'flex',
          flexShrink: 0,
          height: 32,
          justifyContent: 'center',
          width: 32,
        }}
      >
        <WarningAmberRoundedIcon fontSize="small" />
      </Box>
      <Typography sx={{ ...adminTypography.sectionTitle, color: adminColors.text }}>
        {title}
      </Typography>
    </DialogTitle>

    <DialogContent sx={adminDialogContentSx}>
      <Typography sx={{ ...adminTypography.body, color: adminColors.text }}>
        {message}
      </Typography>
    </DialogContent>

    <DialogActions sx={adminDialogActionsSx}>
      <Button
        disabled={submitting}
        onClick={onCancel}
        size="small"
        variant="outlined"
        sx={adminCombineSx(adminButtonSx, adminButtonToneSx.secondary)}
      >
        Cancel
      </Button>
      <Button
        disabled={submitting}
        onClick={onConfirm}
        size="small"
        variant="contained"
        sx={adminCombineSx(adminButtonSx, adminButtonToneSx[confirmTone])}
      >
        {confirmButtonText}
      </Button>
    </DialogActions>
  </Dialog>
);

export default React.memo(AdminConfirmationDialog);
